import {
  cancel,
  get,
  index,
  post,
  put,
  checkNumber,
} from "src/api/purchase-bill";

import PurchaseBillForm from "src/modules/purchase-order/components/forms/PurchaseBillForm.vue";
import { findIndex } from "src/assets/scripts/utilities/helpers";

const getInitialState = () => {
  return {
    purchaseBills: [],
    purchaseBill: {},
  };
};

const preparePurchaseBill = (purchaseBill) => {
  const { created_by, freight, lineitems, po_id, seller, ...rest } =
    purchaseBill;

  return {
    ...rest,
    created_by: created_by?._id || created_by,
    freight: freight ?? 0,
    lineitems: lineitems.map((lineItem) => {
      delete lineItem.disable;

      return lineItem;
    }),
    po_id: po_id.map((po) => (po._id ? po._id : po)),
    seller: seller?._id || seller,
  };
};

export const usePurchaseBillStore = defineStore("purchase-bill", () => {
  const { state: formState, toggle: togglePurchaseBillForm } = useDrawer({
    component: PurchaseBillForm,
  });

  let state = reactive(getInitialState());

  const setPurchaseBill = (updatedPurchaseBill) => {
    state.purchaseBills[
      findIndex(state.purchaseBills, updatedPurchaseBill, "_id")
    ] = updatedPurchaseBill;

    state.purchaseBill = updatedPurchaseBill;
  };

  const cancelPurchaseBill = async (params) => {
    try {
      const response = await cancel(params);

      await getPurchaseBills();

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const getPurchaseBill = async (id) => {
    try {
      const response = await get(id);

      state.purchaseBill = response?.data?.data;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const filters = ref({
    po_id: null,
    status: null,
    startDate: null,
    endDate: null,
  });

  const { filter, pagination, params } = usePagination(filters);

  const getPurchaseBills = async (options = {}) => {
    try {
      options = unref(options);

      if (options?.filters) {
        filters.value = options?.filters;

        delete options.filters;
      }

      options.params = { ...unref(params), ...options.params };

      const response = await index({
        ...unref(options),
      });

      state.purchaseBills = response?.data?.data?.data;

      pagination.value.rowsNumber = response?.data?.data?.count;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postPurchaseBill = async (purchaseBill, options) => {
    try {
      const response = await post(preparePurchaseBill(purchaseBill), options);

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const putPurchaseBill = async (purchaseBill) => {
    try {
      const response = await put(preparePurchaseBill(purchaseBill));

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const isDuplicate = async (number) => {
    const response = await checkNumber(number);

    return response;
  };

  const addFile = (file) => {
    const pbIndex = findIndex(
      state.purchaseBills,
      { _id: file.bill_id },
      "_id",
    );

    if (pbIndex !== -1) {
      state.purchaseBills[pbIndex].files.unshift(file);
    }
  };

  const updateFile = (file) => {
    const pbIndex = findIndex(
      state.purchaseBills,
      { _id: file.bill_id },
      "_id",
    );

    const fileIndex = findIndex(
      state.purchaseBills[pbIndex].files,
      { _id: file._id },
      "_id",
    );

    if (pbIndex !== -1 && fileIndex !== -1) {
      if (file.status === "Active") {
        state.purchaseBills[pbIndex].files[fileIndex] = file;
      } else {
        state.purchaseBills[pbIndex].files.splice(fileIndex, 1);
      }
    }
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    formState,
    togglePurchaseBillForm,

    filter,
    filters,
    pagination,

    ...toRefs(state),

    addFile,
    updateFile,
    setPurchaseBill,

    cancelPurchaseBill,
    getPurchaseBill,
    getPurchaseBills,
    postPurchaseBill,
    putPurchaseBill,
    isDuplicate,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(usePurchaseBillStore, import.meta.hot),
  );
}
